import { ApiGenericResponse } from "../../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";

const ENDPOINT = "/dashboard/";

export class RemoveDashboardSharingTokenCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";

    constructor(dashboardId: number) {
        super();
        this.endPoint += dashboardId + "/sharingToken";
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand();
        return new ApiGenericResponse(res);
    }
}
